"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChildWrapper = exports.StyledSliderContainer = exports.StyledSliderCarouselWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_spring_1 = require("react-spring");
exports.StyledSliderCarouselWrapper = components_core_1.styled.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
exports.StyledSliderContainer = components_core_1.styled.div `
  touch-action: pan-x pan-y;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  display: ${(props) => props.totalColumnCount <= props.visibleColumnCount ? 'flex' : 'grid'};
  grid-template-columns: ${props => `repeat(${props.totalColumnCount}, ${(1 / props.visibleColumnCount) *
    100}%)`};
  ${(props) => props.totalColumnCount <= props.visibleColumnCount &&
    'justify-content: space-around;'}
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    justify-content: ${(props) => props.totalColumnCount === props.visibleColumnCount &&
    props.visibleColumnCount >= 2
    ? 'space-between'
    : props.totalColumnCount < props.visibleColumnCount
        ? 'flex-start'
        : 'unset'};
  }
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    grid-template-columns: ${(props) => `repeat(${props.totalColumnCount}, ${(1 / props.visibleColumnCount) *
    100}%)`};
  }
`;
exports.StyledChildWrapper = (0, components_core_1.styled)(react_spring_1.animated.div) `
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  white-space: normal;
  will-change: transform;
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    ${(props) => !props.singleelement && 'width: 100%;'}
  }
`;
